import {
    trackEvent,
    eventNameConstants,
    stepInteractionConstants,
    interactionTypeConstants,
} from 'dibs-tracking';
const { EVENT_CONTACT_DEALER } = eventNameConstants;
const { STEP_INTERACTION_PDP_CHAT_BOX_DISPLAY } = stepInteractionConstants;
const { INTERACTION_TYPE_CONTACT_DEALER } = interactionTypeConstants;

export const trackChatOpen = (isMinimized: boolean): void => {
    const label = `pdp chat box ${isMinimized ? 'minimized' : 'open'}`;
    trackEvent(
        {
            category: 'contact dealer',
            action: 'pdp chat box displayed',
            label,
            eventName: EVENT_CONTACT_DEALER,
            interaction_type: INTERACTION_TYPE_CONTACT_DEALER,
            step_interaction_name: STEP_INTERACTION_PDP_CHAT_BOX_DISPLAY,
            trigger: label,
        },
        null
    );
};
